import React from 'react';
import Baumumfang from '../components/Baumumfang';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BaumumfangJochberg() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="baumumfang-jochberg-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="baumumfang-jochberg-heading">BAUMUMFANG</h1>
        </div>

        <Baumumfang ort="jochberg" />
      </div>
    </div>
  );
}

export default BaumumfangJochberg;
